import { Avatar as AvatarComponent } from "@packages/ds";

// Re-export the Avatar component and its properties
export const Avatar = AvatarComponent;
export const Root = AvatarComponent.Root;
export const Image = AvatarComponent.Image;
export const Fallback = AvatarComponent.Fallback;

// Export default for backward compatibility
export default Avatar;
